import * as actionType from '../store/action'

export const setToggleMenu = () => dispatch => dispatch({ type: actionType.TOGGLE_MENU })

export const setToggleCart = action => dispatch => dispatch({ type: actionType.TOGGLE_CART, payload: action })

export const setPreload = action => dispatch => dispatch({ type: actionType.SET_PRELOAD, payload: action })

export const setToggleSidebar = action => dispatch => dispatch({ type: actionType.TOGGLE_SIDEBAR, payload: action })
